import { render, staticRenderFns } from "./VerificationPaymentData.vue?vue&type=template&id=761c89d1&scoped=true&"
import script from "./VerificationPaymentData.vue?vue&type=script&lang=js&"
export * from "./VerificationPaymentData.vue?vue&type=script&lang=js&"
import style0 from "./VerificationPaymentData.vue?vue&type=style&index=0&id=761c89d1&scoped=true&lang=css&"
import style1 from "./VerificationPaymentData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761c89d1",
  null
  
)

export default component.exports